/**
 * Formule Retenue : un compte qui n'a acheté que le suivi des retenues de garantie.
 * Le serveur refuse en 403 (`FORMULE_RETENUE`) tout ce qui sort de ce périmètre ;
 * l'appli ne monte même pas les pages concernées.
 */

import type { User } from '@/types';

export function estFormuleRetenue(user: Pick<User, 'formule'> | null | undefined): boolean {
    return user?.formule === 'RETENUE';
}

/** L'accueil d'un compte Retenue : sa liste de retenues, pas le tableau de bord. */
export const ACCUEIL_FORMULE_RETENUE = '/retentions';

const RUBRIQUES_OUVERTES = ['/retentions', '/clients', '/settings', '/mentions-legales', '/cgu', '/politique-confidentialite'];

export function routeOuverteFormuleRetenue(pathname: string): boolean {
    return RUBRIQUES_OUVERTES.some((rubrique) => pathname === rubrique || pathname.startsWith(`${rubrique}/`));
}

/**
 * Onglets des Paramètres dont les routes serveur sont fermées à la formule Retenue
 * (documents, facturation électronique, modules, équipe, export des données).
 * Entreprise et Compte restent : leurs routes (`/v1/settings`, `/v1/auth`) sont ouvertes.
 */
const ONGLETS_PARAMETRES_FERMES = ['documents', 'facturation', 'modules', 'equipe', 'donnees'];

export function ongletParametresOuvert(user: Pick<User, 'formule'> | null | undefined, onglet: string): boolean {
    return !(estFormuleRetenue(user) && ONGLETS_PARAMETRES_FERMES.includes(onglet));
}

/** Émis par le client HTTP sur un 403 `FORMULE_RETENUE` ; la mise en page le dit à l'artisan. */
export const EVENEMENT_HORS_FORMULE = 'formule:hors-perimetre';

/** Seule cette valeur exacte de `?formule=` ouvre l'inscription à la formule Retenue. */
export const PARAM_FORMULE_RETENUE = 'retenue';
